"use client";

import { useEffect, useRef, useState } from "react";
import { onGameBalance } from "./gameBalanceEvent";

const useGameBalance = (cashierBalance: number, syncedAt?: number) => {
  const [gameBalance, setGameBalance] = useState<number>();
  const isLockedRef = useRef(false);

  useEffect(
    () =>
      onGameBalance(({ isLocked, balance }) => {
        isLockedRef.current = isLocked;
        if (balance !== undefined) {
          setGameBalance(balance);
        }
      }),
    [],
  );

  useEffect(() => {
    if (isLockedRef.current) {
      return;
    }
    setGameBalance(undefined);
  }, [cashierBalance, syncedAt]);

  return gameBalance ?? cashierBalance;
};

export default useGameBalance;
